import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { useNavigate, useParams } from '../../../navigation';
import { TTOrderV2 } from '../../../interfaces/order';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { TTRestaurantProfile } from '../../../interfaces/restaurant';

type Props = {};

const OrderBanner: React.FC<Props> = () => {
  const navigate = useNavigate();
  // @ts-ignore
  const { r_id } = useParams();

  const order = useSelector<RootState, TTOrderV2>(state => {
    return state.order.order;
  });

  const profile = useSelector<RootState, TTRestaurantProfile | null>(
    state => state.restaurant.profile,
  );

  return (
    <>
      {
        <div
          className="w-full bg-surface fixed bottom-0 md:-mx-8 lg:-mx-16 xl:-mx-32"
          onClick={() => {
            logEvent(getAnalytics(), 'view_order_clicked');
            navigate(`/feed/restaurants/${r_id}/order/${order.id}`);
          }}
        >
          <div className="flex flex-row bg-primary rounded-t-md p-4 justify-center items-center shadow-sm md:mx-8 lg:mx-16 xl:mx-32">
            <div className="flex flex-col justify-center leading-normal ">
              <div className="flex items-center">
                <span className="text-white font-bold text-lg">
                  Current {profile?.config?.use_order_lang ? 'Order' : 'Tab'}
                </span>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default OrderBanner;
